import axios from "../../utils/api";
import {
  FETCH_ERROR,
  SIGN_IN,
  GET_USER_INFORMATION,
  IS_GETTING_USER_INFO,
  GET_USER_INFORMATION_FAILURE,
  CONTINUE_AS_GUEST,
  UPDATING_BILLING_INFORMATION_SUCCESS,
  SET_LOGGIN_LOADING,
} from "../../constants/ActionTypes";
import { setShippingInformation, updateContactEmail } from "./User";

/**
 * Login user
 * @returns
 */
export const signIn = data => {
  return dispatch => {
    dispatch({
      type: SET_LOGGIN_LOADING,
      payload: true,
      authError: null,
    });
    axios
      .post(`/api/login/`, data, {
        withCredentials: true,
        maxRedirects: 0,
      })
      .then(({ data }) => {
        dispatch({
          type: SET_LOGGIN_LOADING,
          payload: false,
          authError: null,
        });
        dispatch({
          type: SIGN_IN,
          payload: data?.user,
        });
      })
      .catch(error => {
        dispatch({
          type: SET_LOGGIN_LOADING,
          payload: false,
          authError: "Invalid email or password",
        });
        dispatch({
          type: FETCH_ERROR,
          payload: error?.response?.message,
          fieldsErrors: error?.response?.message,
        });
      });
  };
};

/**
 * Get user information
 * @returns
 */
export const getUserInformation = () => {
  return dispatch => {
    dispatch(isGettingUserInfo(true));
    axios
      .get(`/api/me/`)
      .then(({ data }) => {
        dispatch(isGettingUserInfo(false));
        dispatch({
          type: GET_USER_INFORMATION,
          payload: data?.user,
        });
        dispatch(setGuest(false));
        // Set the billing address for the user
        dispatch({
          type: UPDATING_BILLING_INFORMATION_SUCCESS,
          payload: data,
        });
        // By default, we set shipping information same as billing
        dispatch(updateContactEmail(data?.user?.email));
        dispatch(setShippingInformation(data));
      })
      .catch(error => {
        dispatch(isGettingUserInfo(false));
        dispatch({
          type: GET_USER_INFORMATION_FAILURE,
        });
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

/**
 * UI mainly
 * @param {*} status
 * @returns
 */
export const isGettingUserInfo = status => ({
  type: IS_GETTING_USER_INFO,
  payload: status,
});

/**
 * Continue as guest
 * @param status
 * @returns {{payload: null, type: string}}
 */
export const setGuest = status => {
  return {
    type: CONTINUE_AS_GUEST,
    payload: status,
  };
};
